<div class="container">
  <div class="row">
    <div class="col-main col-lg-4 col-sm-6 ms-auto me-auto">
      <div class="card card-register">
        <h3 class="title">{{'signin'|traduccion}}</h3>
        <form class="register-form" [formGroup]="form" (ngSubmit)="login()">
          <label>{{'email'|traduccion}}</label>
          <div class="input-group form-group-no-border" [ngClass]="{'input-group-focus':focus===true}">
            <div class="input-group-prepend">
              <span class="input-group-text">
                <i class="nc-icon nc-email-85"></i>
              </span>
            </div>
            <input formControlName="usernameOrEmail" name="usernameOrEmail" type="text" class="form-control" [placeholder]="'email'|traduccion"
              (focus)="focus=true" (blur)="focus=false">
            </div>
            @if (usernameOrEmail.invalid && (usernameOrEmail.dirty || usernameOrEmail.touched)) {
              <div class="text-danger">
                @if (usernameOrEmail.errors.required) {
                  <small>{{'email.errors.required'|traduccion}}<br></small>
                }
                @if (usernameOrEmail.errors.email) {
                  <small>{{'email.errors.email'|traduccion}}<br></small>
                }
              </div>
            }
            <label>{{'password'|traduccion}}</label>
            <div class="input-group form-group-no-border" [ngClass]="{'input-group-focus':focus1===true}">
              <div class="input-group-prepend">
                <span class="input-group-text">
                  <i class="nc-icon nc-key-25"></i>
                </span>
              </div>
              <input formControlName="password" name="password" type="password" class="form-control" [placeholder]="'password'|traduccion" (focus)="focus1=true"
                (blur)="focus1=false">
              </div>
              @if (password.invalid && (password.dirty || password.touched)) {
                <div class="text-danger">
                  @if (password.errors.required) {
                    <small>{{'password.errors.required'|traduccion}}<br></small>
                  }
                  @if (password.errors.minlength) {
                    <small>{{'password.errors.minlength'|traduccion}}<br></small>
                  }
                </div>
              }
              <button [disabled]="!form.valid" class="btn btn-outline-neutral btn-block btn-round">{{'signin'|traduccion}}</button>
            </form>
            <div class="forgot">
              <a (click)="_goTo('signup')" class="btn btn-link text-info">{{'want_signup'|traduccion}}</a>
            </div>
            <div class="forgot">
              <a (click)="_goTo('reset')"  class="btn btn-link btn-terciary">{{'forgot_password?'|traduccion}}</a>
            </div>
          </div>
        </div>
      </div>
      <div class="footer register-footer text-center">

      </div>
    </div>
